import { Button, Form, Input, message } from 'antd';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { reqChangePassword } from '../../services';
import { regrexAtLeast } from '../../constant';


const ChangePassword: React.FC = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const handleChangePassword = async (values: any) => {
        setLoading(true);
        try {
            await reqChangePassword(values);
            message.success('Đổi mật khẩu thành công!');
            // Redirect về trang home sau 1.5 giây
            setTimeout(() => {
                history.push('/');
            }, 1500);
        } catch (error) {
            console.error('Error changing password:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 overflow-hidden">
            <div className='h-full flex flex-col px-4 sm:px-6 py-4'>
                {/* Header Section */}
                <div className='flex-shrink-0'>
                </div>

                {/* Form Section */}
                <div className='flex-1 bg-white rounded-lg shadow-lg border border-gray-100 overflow-hidden flex flex-col min-h-0'>
                    <div className='p-6 flex-1 flex items-center justify-center'>
                        <div className='w-full max-w-md'>
                            <div className='bg-gradient-to-r from-slate-50 to-gray-50 border border-slate-200 rounded-xl p-8 shadow-sm'>
                                <div className='text-center mb-6'>
                                    <h2 className='text-xl font-semibold text-gray-900 mb-2'>Thay đổi mật khẩu</h2>
                                    <p className='text-sm text-gray-600'>Nhập thông tin để cập nhật mật khẩu mới</p>
                                </div>

                                <Form 
                                    form={form}
                                    onFinish={handleChangePassword} 
                                    layout="vertical" 
                                    className='space-y-4'
                                >
                                    <Form.Item
                                        label={<span className="text-sm font-medium text-gray-700">Mật khẩu cũ</span>}
                                        rules={[{
                                            required: true,
                                            validateTrigger: 'onFinish',
                                            message: 'Vui lòng nhập mật khẩu cũ'
                                        },
                                        { min: 8, validateTrigger: 'onFinish', message: 'Mật khẩu phải có ít nhất 8 ký tự' },
                                        ]}
                                        name='current_password'
                                    >
                                        <Input.Password 
                                            className='h-12 rounded-lg border-gray-300 focus:border-blue-500 focus:ring-blue-500' 
                                            placeholder='Nhập mật khẩu hiện tại'
                                        />
                                    </Form.Item>
                                    
                                    <Form.Item
                                        label={<span className="text-sm font-medium text-gray-700">Mật khẩu mới</span>}
                                        rules={[{
                                            required: true,
                                            validateTrigger: 'onFinish',
                                            message: 'Vui lòng nhập mật khẩu mới'
                                        },
                                        { min: 8, validateTrigger: 'onFinish', message: 'Mật khẩu phải có ít nhất 8 ký tự' },
                                        {
                                            validateTrigger: 'onFinish',
                                            validator: (_, value) =>
                                                regrexAtLeast.test(value) ? Promise.resolve() :
                                                    Promise.reject('Mật khẩu có chứa ít nhất 1 kí tự số và 1 kí tự chữ cái')
                                        }
                                        ]}
                                        name='new_password'
                                    >
                                        <Input.Password 
                                            className='h-12 rounded-lg border-gray-300 focus:border-blue-500 focus:ring-blue-500' 
                                            placeholder='Nhập mật khẩu mới'
                                        />
                                    </Form.Item>
                                    
                                    <Form.Item
                                        label={<span className="text-sm font-medium text-gray-700">Xác nhận mật khẩu mới</span>}
                                        rules={[{
                                            required: true,
                                            validateTrigger: 'onFinish',
                                            message: 'Vui lòng xác nhận mật khẩu mới'
                                        },
                                        { min: 8, validateTrigger: 'onFinish', message: 'Mật khẩu phải có ít nhất 8 ký tự' },
                                        {
                                            validateTrigger: 'onFinish',
                                            validator: (_, value) =>
                                                regrexAtLeast.test(value) ? Promise.resolve() :
                                                    Promise.reject('Mật khẩu có chứa ít nhất 1 kí tự số và 1 kí tự chữ cái')
                                        },
                                        ({ getFieldValue }) => ({
                                            validateTrigger: 'onFinish',
                                            validator(_, value) {
                                                if (!value || getFieldValue('new_password') === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('Mật khẩu không trùng khớp'));
                                            },
                                        }),
                                        ]}
                                        name='confirm_new_password'
                                    >
                                        <Input.Password 
                                            className='h-12 rounded-lg border-gray-300 focus:border-blue-500 focus:ring-blue-500' 
                                            placeholder='Nhập lại mật khẩu mới'
                                        />
                                    </Form.Item>
                                    
                                    <Button 
                                        className='w-full h-12 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 border-0 rounded-lg font-medium text-white shadow-lg hover:shadow-xl transition-all duration-200' 
                                        type='primary' 
                                        htmlType='submit'
                                        loading={loading}
                                    >
                                        {loading ? 'Đang cập nhật...' : 'Cập nhật mật khẩu'}
                                    </Button>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;